import React from "react";
import { $t } from '@/modules/i18n';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
    };

  }
  handleChange(e) {
    this.setState({
      lang: e.target.value,
    })
  }
  render() {
    const msg = this.props.Message;
    return (
      <footer>
        <div className="container">
          <div className="flex-box">
            <div className="social">
              <a href={msg.instagramLink} target="_blank" rel="noopener noreferrer">{msg.instagram}</a>
              <a href={msg.linkedinLink} target="_blank" rel="noopener noreferrer">{msg.linkedin}</a>
              <a href={msg.careerLink} target="_blank" rel="noopener noreferrer">{$t(msg.career)}</a>
              <a href="pdf/terms-and-condition.pdf" target="_blank" rel="noopener noreferrer">{$t(msg.termsAndCondition)}</a>
            </div>
            <div className="copyright">&copy; {$t(msg.copyright)}
              <img src={require("@ndsc/assets/images/icon_lang.svg")} alt="select language" className="icon-lang" style={{marginLeft: "12px"}}/>
              <select name="" id="lang" onChange={e => this.props.onInputChange(e.target.value)} defaultValue={this.props.value} className="select-lang">
                <option value='id'>ID</option>
                <option value='en'>EN</option>
              </select>
            </div>
          </div>
        </div>
      </footer>

    );
  }
}

export default Footer;